export default __webpack_public_path__ + "static/Logo-6d20e3b78eedefdb2ef6b0df5072f6d7.png";